import wixUsers from 'wix-users';
import {session} from 'wix-storage';
import wixWindow from 'wix-window';

//denna döljer antingen knappen mitt premium eller bli premium beroende på 
let user = wixUsers.currentUser;
$w.onReady( () => { 
  if (wixUsers.currentUser.loggedIn) {
    user.getPricingPlans().then((plans) => {
          if (plans.length > 0) {
              $w('#premium').label = "MITT PREMIUM >";
              $w('#premium').link = "/mitt-premium";
          } else {
              $w('#premium').label = "BLI PREMIUM >";
              $w('#premium').link = "/medlemskap";
          }
      })

  } else {
      $w('#premium').label = "BLI PREMIUM >";
      $w('#premium').link = "/medlemskap";
  }
});

/*
popup på alla sidor som visas första gången man besöker en sida. Den fungerar genom att kolla om item:et firstTimePopup finns på din browser. 
Om den inte hittar den visar den pop-upen och sparar den frmaöver så att du inte ser popup:en igen. 
Den väntar i 1 sekund så att man kan ha kod som blockar pop-upen (genom att spara firstTimePopup på ens browser) hinner köras på de sidor man inte vill ha pop-up:en på.
Vill man göra en ny, byt då namn på firstTimeMaillistShown.//#endregion

&& !wixUsers.currentUser.loggedIn betyder att den endast visas till folk som inte är inloggade

*/
$w.onReady(function () {
    setTimeout(()=>{if(!session.getItem("firstTimeMaillistShown") && !wixUsers.currentUser.loggedIn) {
    wixWindow.openLightbox("Missa inget roligt!");
    session.setItem("firstTimeMaillistShown", "yes");
  }
  }, 10000)
  
} );

/*

Lägg in detta på sidan som popup:en skickar en till

import {local} from 'wix-storage';

$w.onReady(function () {
	local.setItem("firstTimePopupShown", "yes");
});

*/